import { Fragment, type ReactNode, useMemo } from 'react'

import { MessageContentStyled } from './styles/MessageContentStyled'
import { MessageLinkStyled } from './styles/MessageLinkStyled'
import { MessageRowStyled } from './styles/MessageRowStyled'
import { MessageStrongStyled } from './styles/MessageStrongStyled'
import {
  type MessageToken,
  tokenizeMessageContent,
} from './tokenizeMessageContent'

export type MessageSender = 'user' | 'llm'

export interface IMessageProps {
  sender: MessageSender
  content: string
}

const renderMessageToken = (token: MessageToken, key: string): ReactNode => {
  switch (token.type) {
    case 'strong':
      return <MessageStrongStyled key={key}>{token.value}</MessageStrongStyled>
    case 'link':
      return (
        <MessageLinkStyled key={key} to={token.href}>
          {token.value}
        </MessageLinkStyled>
      )
    default:
      return <Fragment key={key}>{token.value}</Fragment>
  }
}

export const Message = ({ sender, content }: IMessageProps) => {
  const tokens = useMemo(() => tokenizeMessageContent(content), [content])

  return (
    <MessageRowStyled $sender={sender}>
      <MessageContentStyled $sender={sender}>
        {tokens.map((token, index) =>
          renderMessageToken(token, `${token.type}-${index}`)
        )}
      </MessageContentStyled>
    </MessageRowStyled>
  )
}
